module.exports = __webpack_public_path__ + "img/oneonone.9e5703b.jpg";